import React from "react";
import Items from "./Items";
import data_product from "./Assets/data.js";
import popular from "../css/popular.css";
const Popular = () => {
  return (
    <div style={popular} className="popular">
      <h1>POPULAR IN WOMEN</h1>
      <hr />
      <div className="popular-item">
        {data_product.map((item, i) => {
          return (
            <Items
              key={i}
              id={item.id}
              name={item.name}
              image={item.image}
              new_price={item.new_price}
              old_price={item.old_price}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Popular;
